'use client'

import { usePageAlt } from '@component/abTest'
import useLogin from '@hooks/useLogin'
import { getRouterHref, URLS } from '@router'
import { isRentData, isSaleData, isVillageData } from '@utils/house'
import { filter, map } from 'lodash-es'
import { Suspense } from 'react'
import OpenHomeLayout, { EnquiryRow } from '../openHomeLayout'
import ContactButton, { LinkEnquiryButton } from './contactButton'

export default function ContactContent({
  data,
  enquiryList,
  title = '',
  successBoxId = '',
  type = ''
}) {
  const isPageAlt = usePageAlt()
  const { isLogin } = useLogin()
  const isVillage = isVillageData(data)
  const showInfoPackButton = isVillage && data.infoPack
  const list = filter(enquiryList, item => item.value !== 'default')

  const viewTitle = (function () {
    const isBuy = isSaleData(data)
    const isRent = isRentData(data)

    if (title) {
      return title
    } else if (isVillage) {
      return 'Ready to make a move?'
    } else if (Boolean(isPageAlt && isLogin && isBuy)) {
      return 'Ask agent instantly about'
    } else if (isRent) {
      return 'Find out more'
    } else {
      return 'I am interested in'
    }
  })()

  return (
    <OpenHomeLayout title={viewTitle}>
      {
        // 如果有infoPack，则优先显示下载按钮
        showInfoPackButton
          ? (
            <EnquiryRow
              text="Get an info pack."
              href={data.infoPack}
              button={
                <LinkEnquiryButton />
              }
            />
          )
          : map(list, item => (
            type === 'cta'
              ? <EnquiryRow
                key={item.value}
                text={item.label}
                href={getRouterHref(URLS.formBuilder, { slug: 'im-interested-in-selling' })}
                button={
                  <LinkEnquiryButton />
                }
              />
              : <EnquiryRow
                key={item.value}
                text={item.label}
                button={
                  <Suspense>
                    <ContactButton
                      data={item}
                      house={data}
                      sendAllAgent
                      successBoxId={successBoxId}
                      enquiryType={type}
                    />
                  </Suspense>
                }
              />
          ))
      }
      <div className='relative flex justify-center opacity-0 transition-opacity duration-1000 pointer-events-none z-[1]' id={successBoxId}>
        <div className='h-48 flex items-center gap-x-8 px-30 bg-white shadow-md rounded-md text-sm absolute top-24'>
          <span className='w-18 h-18 bg-[#17A11A] rounded-half grid place-items-center'>
            <i className='icon icon-correct text-white !text-xs font-bold'></i>
          </span>
          An agent will be in touch shortly.
        </div>
      </div>
    </OpenHomeLayout>
  )
}